import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { IMG } from "../common/CONST"
import { InnPopUpList } from "./inn/InnPopUpList"
import { IPageResponse } from "../../types/IPageResponse"
import { ICheckActionRequiredResponse } from "../../types/messenger/ICheckActionRequiredResponse"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { ADMIN_COMPANY_NEW_ROUTE, ADMIN_USER_ROUTE } from "../../routes"
import { CONFIG } from "../../CONFIG"
import { CurrencyPayerPopUpList } from "./currencyPayer/CurrencyPayerPopUpList"

export const AdminQuickActions = () => {
  const navigate = useNavigate()

  const [showInn, setShowInn] = useState(false)
  const [showCurrencyPayer, setShowCurrencyPayer] = useState(false)
  const [numInn, setNumInn] = useState<number>(0)
  const [numCurrencyPayer, setNumCurrencyPayer] = useState<number>(0)

  const fetchUnread = () => {
    TrinityAPI.getActionsRequired(response => {
      if (response.status === 200) {
        const actionRequiredList: IPageResponse<ICheckActionRequiredResponse> = response.data
        let innCount = 0
        let currencyPayerCount = 0
        actionRequiredList.items.forEach(i => {
          innCount += i.type === "INN" ? i.num : 0
          currencyPayerCount += i.type === "CURRENCY_PAYER" ? i.num : 0
        })
        setNumInn(innCount)
        setNumCurrencyPayer(currencyPayerCount)
      }
    })
  }

  useEffect(() => {
    fetchUnread()

    const intervalId = setInterval(() => {
      fetchUnread()
    }, CONFIG.fetchUnreadsInterval)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <>
      <section className="quick-actions">
        <div className="quick-action-block" onClick={() => navigate(ADMIN_COMPANY_NEW_ROUTE)}>
          <div className="quick-action-icon">
            <img src={IMG.companies} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Добавить компанию</p>
        </div>
        <div className="quick-action-block" onClick={() => navigate(`${ADMIN_USER_ROUTE}?role=ROLE_MANAGER`)}>
          <div className="quick-action-icon">
            <img src={IMG.profile} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Реестр менеджеров</p>
        </div>
        <div className="quick-action-block" onClick={() => navigate(`${ADMIN_USER_ROUTE}?role=ROLE_CLIENT`)}>
          <div className="quick-action-icon">
            <img src={IMG.contr} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Реестр пользователей</p>
        </div>
        <div className="quick-action-block lock" id="admin10" onClick={() => setShowInn(true)}>
          <div className="quick-action-icon">
            <img src={IMG.lock} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">
            Реестр рублевых плательщиков{" "}
            {numInn === 0 ? (
              ""
            ) : (
              <span
                className="span-actions"
                style={{
                  display: "inline-block",
                  marginLeft: "5px"
                }}
              >
                {numInn}
              </span>
            )}
          </p>
        </div>
        <div className="quick-action-block lock" id="admin10" onClick={() => setShowCurrencyPayer(true)}>
          <div className="quick-action-icon">
            <img src={IMG.lock} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">
            Реестр валютных плательщиков{" "}
            {numCurrencyPayer === 0 ? (
              ""
            ) : (
              <span
                className="span-actions"
                style={{
                  display: "inline-block",
                  marginLeft: "5px"
                }}
              >
                {numCurrencyPayer}
              </span>
            )}
          </p>
        </div>
      </section>

      <InnPopUpList visible={showInn} setVisible={setShowInn} />
      <CurrencyPayerPopUpList visible={showCurrencyPayer} setVisible={setShowCurrencyPayer} />
    </>
  )
}
